exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".launchDate {\n  color: firebrick; }\n\n.gameCard {\n  box-shadow: 0px 5px 6px 1px #bdbdbd; }\n\n.gameImage {\n  height: 200px; }\n\n.content {\n  margin-top: -40px; }\n\n.answers {\n  background-color: rgba(236, 236, 236, 0.9);\n  margin-left: -15px;\n  margin-right: -15px; }\n\n.stats {\n  margin-bottom: 10px;\n  padding-bottom: 5px;\n  font-size: 28px;\n  box-shadow: 0px 5px 6px 1px #bdbdbd; }\n\n.correct {\n  color: #43A047; }\n\n.promos {\n  color: gray; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/games/games.component.scss
// module id = ../../../../../src/app/games/games.component.scss
// module chunks = main